import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import * as _ from "../../../util/lodash";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import { ConfigService } from "../../../services";
import { positions, sizes, colors, widths, textAlignments, documentTypes as DOCUMENT_TYPES, icons } from "../../../enums";
import { UploaderMessages } from "./file-utils";
import Layout from "../layout";
import Button from "../button";
import Label from "../label";
import LibrarySelect from "../../abstractions/library-select";
/**
 * view for selecting/uploading a file
 */

var FileSelectView = createComponent({
  displayName: 'FileSelectView',
  propTypes: {
    showUploadButton: PropTypes.bool,
    showSelectButton: PropTypes.bool,
    showVideoUrlButton: PropTypes.bool,
    uploadButtonText: PropTypes.string,
    selectButtonText: PropTypes.string,
    videoButtonText: PropTypes.string,
    dragAndDropText: PropTypes.string,
    onFileSelected: PropTypes.func.isRequired,
    onSelectFromLibrary: PropTypes.func.isRequired,
    onShowVideoInput: PropTypes.func.isRequired,
    libraryRef: PropTypes.string,
    containerRef: PropTypes.string,
    documentTypes: PropTypes.array,
    hasFluidButtons: PropTypes.bool,
    displayFilterScope: PropTypes.bool.isRequired
  },
  defaultProps: {
    showUploadButton: true,
    showSelectButton: true,
    showVideoUrlButton: true,
    libraryRef: '',
    containerRef: '',
    documentTypes: [DOCUMENT_TYPES.IMAGE],
    uploadButtonText: '',
    selectButtonText: '',
    videoButtonText: '',
    dragAndDropText: '',
    hasFluidButtons: false
  },
  refs: 'inputRef',
  render: function render(props) {
    var showUploadButton = props.showUploadButton,
        showSelectButton = props.showSelectButton,
        showVideoUrlButton = props.showVideoUrlButton,
        onShowVideoInput = props.onShowVideoInput,
        libraryRef = props.libraryRef,
        containerRef = props.containerRef,
        documentTypes = props.documentTypes,
        uploadButtonText = props.uploadButtonText,
        selectButtonText = props.selectButtonText,
        videoButtonText = props.videoButtonText,
        dragAndDropText = props.dragAndDropText,
        displayFilterScope = props.displayFilterScope,
        onFileSelected = props.onFileSelected,
        isVideoOnly = showVideoUrlButton && !showSelectButton && !showUploadButton;

    var browseFile = function browseFile() {
      props.refs.inputRef.click();
    };

    var ConsoleKitConfig = _valuesInstanceProperty(ConfigService).call(ConfigService);

    return /*#__PURE__*/React.createElement("div", {
      className: "upload-view file-select-view"
    }, /*#__PURE__*/React.createElement("div", {
      className: "upload-view__inner"
    }, /*#__PURE__*/React.createElement(Layout, {
      isFluidHeight: true,
      padding: {
        horizontal: 'small'
      },
      columnStyles: {
        textAlign: textAlignments.CENTER,
        verticalAlign: positions.verticalAlign.MIDDLE
      },
      style: {
        margin: 0
      }
    }, /*#__PURE__*/React.createElement(Layout.Row, {
      columns: widths.TWO
    }, /*#__PURE__*/React.createElement(Layout.Column, {
      columnWidth: widths.NINE
    }, /*#__PURE__*/React.createElement("input", {
      ref: props.setInputRef,
      type: "file",
      style: {
        display: 'none'
      },
      onChange: onFileSelected
    }), /*#__PURE__*/React.createElement(Label, {
      icon: isVideoOnly ? icons.EDIT : icons.UPLOAD,
      text: dragAndDropText || (isVideoOnly ? UploaderMessages.ENTER_VIDEO_URL : UploaderMessages.DRAG_AND_DROP_FILES_LABEL),
      size: sizes.X5,
      color: colors.BASE
    })), /*#__PURE__*/React.createElement(Layout.Column, {
      columnWidth: widths.SEVEN
    }, /*#__PURE__*/React.createElement(Button.Group, {
      isFluid: props.hasFluidButtons,
      layout: "vertical"
    }, showUploadButton ? /*#__PURE__*/React.createElement(Button.Primary, {
      id: "uploadButton",
      text: uploadButtonText || UploaderMessages.UPLOAD_NEW,
      size: sizes.X1,
      onClick: browseFile,
      isFluid: props.hasFluidButtons
    }) : null, showSelectButton ? /*#__PURE__*/React.createElement(LibrarySelect.Modal, {
      trigger: /*#__PURE__*/React.createElement(Button.Primary, {
        onClick: _.noop,
        text: selectButtonText || UploaderMessages.SELECT_FROM_LIBRARY,
        size: sizes.X1
      }),
      onAssetSelected: props.onSelectFromLibrary,
      libraryRef: libraryRef,
      containerRef: containerRef,
      documentTypes: documentTypes,
      CKConfig: ConsoleKitConfig,
      displayFilterScope: displayFilterScope,
      onFileSelected: onFileSelected
    }) : null, showVideoUrlButton ? /*#__PURE__*/React.createElement(Button.Primary, {
      id: "videoButton",
      text: videoButtonText || UploaderMessages.VIDEO_URL,
      size: sizes.X1,
      onClick: onShowVideoInput,
      isFluid: props.hasFluidButtons
    }) : null))))));
  }
});
export default FileSelectView;
//# sourceMappingURL=file-select.js.map